import React from "react";
import {createResource, fetchActivitySno} from "../../appRedux/actions/ActivityClosure";
import {connect} from "react-redux";
import {Route, Switch} from "react-router-dom";
import Create from "../ActivityClosure/create";
import {faviconDynamicFunction} from "../../util/methods";

class ActivityClosure extends React.Component {

  createResource = (values) => {
    this.props.createResource(values);
  };

  handleFormChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  render() {
    const {match, resource, loading,authUser, resourceName} = this.props;
    faviconDynamicFunction(authUser);
    return (<div>
      <h2>Activity Closure</h2>

      <Switch>
        <Route path={`${match.url}`} exact
               render={(props) => <Create data={{}}
                                          resource={resourceName}
                                          title = {'CREATE'}
                                          onSubmit={this.createResource}
                                          clearProps = {this.props.clearProps}
                                          loading = {loading}
                                          onChange={this.handleFormChange}
                                          activities = {this.props.activities}
                                          fetchActivitySno = {this.props.fetchActivitySno}
                                          {...props}
               />
               }/>
      </Switch>
    </div>)
  }
}
const mapStateToProps = ({commonData,auth, activityClosure}) => {
  return {
    authUser: auth.authUser,
    loading: commonData.loading,
    modules: commonData.modules,
    activities : activityClosure.activitySno,
    resource: activityClosure.resource,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    createResource,
    fetchActivitySno,
  };
}
export default connect(mapStateToProps, mapDispatchToProps())(ActivityClosure);

